import React from 'react';
import { BsMegaphone } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditMarketing = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsMegaphone',
				label: 'megaphone',
				component: BsMegaphone,
			}}
			defaultTheme="purple"
			widgetType="marketing"
		/>
	);
};

export default EditMarketing;
